import envConfig from '@nile/home/src/Config/env';
import { getBrandingLogoAndName } from '@nile/components';
import React, { useState, useEffect } from 'react';
import {
  SkeletonBodyText,
  SkeletonThumbnail
} from '@superops/ui-design-system';
import styled from 'styled-components';
import { setFavIconName } from '@nile/components/src/Utils/setFaviconAndAppTitle';

const BrandingLogoWrapper = styled.div`
  .msp-branding {
    height: fit-content;
  }

  .msp-name {
    font-size: 24px;
    line-height: 29px;
    max-width: 600px;
    text-align: left;
  }

  .branding-loader {
    .Polaris-SkeletonBodyText__SkeletonBodyTextContainer {
      flex: 1;
      height: fit-content;
      margin-left: 20px;
      max-width: 250px;
    }
  }
`;

const BrandingLogoIcon = styled.img`
  max-height: ${(props) => (props.maxHeight ? props.maxHeight : '60px')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '60px')};
`;

export default function BrandingLogo({
  height,
  width,
  maxHeight = '60px',
  maxWidth = '200px',
  hideName,
  alignVertical,
  enableFavIconBrand = false,
  marginNone = false,
  fullWidth = true
}) {
  const [mspBrandingInfo, setMspBrandingInfo] = useState({
    name: null,
    logoDownloadURL: null
  });
  const [logoFetching, setLogoFetching] = useState(false);

  const getMspLogoAndName = async () => {
    setLogoFetching(true);
    const { name, logoDownloadURL, favIconURL } =
      await getBrandingLogoAndName();
    setMspBrandingInfo({
      name: name || null,
      logoDownloadURL: logoDownloadURL || null
    });

    if (enableFavIconBrand) {
      setFavIconName(name, favIconURL);
    }
    setLogoFetching(false);
  };

  useEffect(() => {
    getMspLogoAndName();
  }, []);

  return (
    <BrandingLogoWrapper
      className={`${marginNone ? '' : 'mb40'} ${
        fullWidth && 'fw'
      } branding-logo`}
    >
      {logoFetching ? (
        <div className="branding-loader fx center fw g10">
          <SkeletonThumbnail size="medium" />
          <SkeletonBodyText size="small" lines={1} />
        </div>
      ) : (
        <div
          className={`msp-branding fw ${alignVertical ? 'grid' : 'fx center'}`}
        >
          <BrandingLogoIcon
            src={
              mspBrandingInfo.logoDownloadURL ||
              `${envConfig.imageRoot}svg/superopsLight.svg`
            }
            alt=""
            height={height}
            width={width}
            maxHeight={maxHeight}
            maxWidth={maxWidth}
          />
          {!hideName && (
            <span className={`msp-name bold ${alignVertical ? '' : 'ml20'}`}>
              {mspBrandingInfo.name || 'SuperOps.ai'}
            </span>
          )}
        </div>
      )}
    </BrandingLogoWrapper>
  );
}
